import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `hl7`,

  name: {
    [LOCALES.EN_US]: `HL7`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.standard, TYPES.protocol],

  tags: [],
} as const satisfies TTerm
